import { generatePath } from 'react-router-dom';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import Banner from '@zenbusiness/zui/Banner';
import Link from '@zenbusiness/zui/Link';

import {
  ENABLE_ZB_BANKING_SUNSET_DASHBOARD_TRANSITION_BANNER,
  ENABLE_ZB_BANKING_SUNSET_PH3_HIGH_RISK_CUSTOMERS,
} from '#client/constants/experimentsFlags';
import * as ROUTES from '#client/constants/routes';

import { WarningIcon } from './BankingTransitionBanner.style';

const FAQ_URL = 'https://help.zenbusiness.com/zenbusiness-banking';

function BankingTransitionBanner() {
  const isTransitionBannerEnabled = useExperimentFlag(ENABLE_ZB_BANKING_SUNSET_DASHBOARD_TRANSITION_BANNER, false);
  // High-risk customers have their accounts closed on Oct 2 instead of Nov 30.
  const isHighRiskCustomer = useExperimentFlag(ENABLE_ZB_BANKING_SUNSET_PH3_HIGH_RISK_CUSTOMERS, false);
  const { businessEntityUuid, entitlements } = useBusinessEntity();

  if (!isTransitionBannerEnabled || !entitlements?.has('banking')) {
    return null;
  }

  const transitionPath = generatePath(ROUTES.entityBanking, { businessEntityUuid, '*': 'transition' });

  return (
    <Banner
      variant="alert"
      title={`ZenBusiness Banking will shut down ${isHighRiskCustomer ? 'Oct 2' : 'Nov 30'}. We have options for you.`}
      subtitle={
        <>
          We have new banking options for you with additional benefits and sign up bonuses. Create a new account with a
          preferred partner or another bank to transfer your funds.{' '}
          <Link
            href={FAQ_URL}
            target="_blank"
            rel="noopener noreferrer"
            size="sm"
            weight="regular"
            family="primary"
            color="inherit"
            clickstreamProps={{ elementName: 'banking_transition_banner_faq_link' }}
          >
            See FAQs for details.
          </Link>
        </>
      }
      clickstreamProps={{ appSection: 'home', elementName: 'banking_transition_banner' }}
      slots={{
        startIcon: <WarningIcon />,
      }}
      slotProps={{
        primaryAction: {
          label: 'Confirm and Choose',
          to: transitionPath,
          clickstreamProps: { elementName: 'banking_transition_banner_cta' },
        },
      }}
    />
  );
}

export default BankingTransitionBanner;
